import style from './../Report.module.scss';
import moment from 'moment';
import { take, sortBy, sumBy } from 'lodash';
import ReportTypeStructure from '../ReportTypeStructure';
import TreatmentsByStaff from './TreatmentsByStaff/TreatmentsByStaff';
import UnfinishedTreatments from './UnfinishedTreatments/UnfinishedTreatments';
import WorkingHoursByStaff, {getTimeLabel} from './WorkingHoursByStaff/WorkingHoursByStaff';
import OutofProtocolTreatments from './OutofProtocolTreatments/OutofProtocolTreatments';

const StaffReport = ({ report, isStandalone, onlyContent }) => {
    const { data } = report;
    const { by_treatments, by_working_time, by_unfinished_treatments, by_outofprotocol_treatments } = data.staff;

    const getByTreatments = () => {
        return take(sortBy(by_treatments.filter(s => s.staff !== null && s.count > 0), 'count').reverse(), 5);
    }

    const getByWorkingHours = () => {
        return take(sortBy(by_working_time.filter(s => s.staff !== null && s.working_time > 0), 'working_time').reverse(), 10)
    }

    const getUnfinishedTreatments = () => {
        return take(sortBy(by_unfinished_treatments.filter(s => s.staff !== null && s.count > 0), 'count').reverse(), 5);
    }

    const getOutofProtocolTreatments = () => {
        return take(sortBy(by_outofprotocol_treatments.filter(s => s.staff !== null && s.count > 0), 'count').reverse(), 5);
    }

    const getStats = () => {
        return {
            total: by_treatments.length,
            working_time: getTimeLabel(sumBy(by_working_time, 'working_time')),
            most_active: sortBy(by_working_time, 'working_time').reverse().at(0)
        }
    }

    const getHeader = () => {
        return (
            <div className='d-flex'>
                <div>
                    <h1>Staff Report</h1>
                    <label className={ style.reportType }>{ moment(report.filters.date_range.startDate).format('ll') } - { moment(report.filters.date_range.endDate).format('ll') }</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        const {total, working_time, most_active} = getStats();
        return (
            <>
                <section>
                    <h5>Staff Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{total}</h3>
                            <label>Total Staff</label>
                        </div>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{working_time}</h3>
                            <label>Total Work Time</label>
                        </div>
                        <div className={[style.card, style.col4].join(' ')}>
                            <h3>{most_active !== undefined ? most_active.staff : 'N/A'}</h3>
                            <label>Most Active Staff</label>
                        </div>
                    </div>
                    <div className={ style.cardRow }>
                        <div className={ [ style.card, style.col6 ].join(' ') } style={ { minHeight: 300 } }>
                            <WorkingHoursByStaff data={ getByWorkingHours() } />
                        </div>
                        <div className={ [ style.card, style.col6 ].join(' ') } style={ { minHeight: 300 } }>
                            <TreatmentsByStaff data={ getByTreatments() } />
                        </div>
                    </div>
                    <div className={ style.cardRow }>
                        <div className={ [ style.card, style.col6 ].join(' ') } style={ { minHeight: 300 } }>
                            <UnfinishedTreatments data={ getUnfinishedTreatments() } />
                        </div>
                        <div className={ [ style.card, style.col6 ].join(' ') } style={ { minHeight: 300 } }>
                            <OutofProtocolTreatments data={ getOutofProtocolTreatments() } />
                        </div>
                    </div>
                </section>
            </>
        )
    }

    return (
        <>
            {onlyContent ? getContent() : <ReportTypeStructure isStandalone={ isStandalone } report={ report } header={ getHeader() } content={ getContent() } />}
        </>
    )
}

export default StaffReport;